import { useExperiments } from '@wix/fe-essentials-standalone';

import { EXPERIMENTS } from '../constants';

type WrongArticleVersion = 'versionA' | 'versionB' | 'versionC' | null;

const useWrongArticleVersion = (): WrongArticleVersion => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });

  const version = experiments.get(EXPERIMENTS.SPECS.WRONG_ARTICLE);

  if (
    version === 'versionA' ||
    version === 'versionB' ||
    version === 'versionC'
  ) {
    return version;
  }

  return null;
};

export default useWrongArticleVersion;
